module.exports = __webpack_public_path__ + "img/nrslogovectorallwhitestacked.798923e0.png";